import { minutesToMilliseconds } from 'date-fns';

import { siteUnitClient } from '@portal-clients/site-unit';

import { useClientQuery } from '@frontend/hooks';

export interface UseSiteUnitProps {
  id: string;
  onError?(error: Error): void;
}

export const getSiteUnitQueryKey = (id: string) => ['site-unit', id];

export const useSiteUnitQuery = ({ id, onError }: UseSiteUnitProps) => {
  return useClientQuery({
    queryKey: getSiteUnitQueryKey(id),
    async onFetch() {
      return await siteUnitClient.get(id);
    },
    staleTime: minutesToMilliseconds(5),
    onError,
  });
};
